import {
    ProductCompareDispatcher as SourceProductCompareDispatcher
} from 'SourceStore/ProductCompare/ProductCompare.dispatcher';

/** @namespace Elganso/Store/ProductCompare/Dispatcher */
export class ProductCompareDispatcher extends SourceProductCompareDispatcher {
    async getCompareList(_dispatch) {
        // Deshabilitamos la comparacion de articulos, no se usa y quitamos una peticion
        return false;
    }
}

export default new ProductCompareDispatcher();
